import { LabeledValue } from '@/data-objects/props/LabeledValue'
import Vue from 'vue'

export const lastOrdersTabs = [
  new LabeledValue(require('@/assets/icons/trade/all-tab.svg?inline'), 'all'),
  new LabeledValue(require('@/assets/icons/trade/buy-tab.svg?inline'), 'buy'),
  new LabeledValue(require('@/assets/icons/trade/sell-tab.svg?inline'), 'sell'),
]

export const lastOrdersCurrentTab = Vue.observable({
  tab: lastOrdersTabs[0],
})

export const changeCurrentTab = ({ value }) => {
  lastOrdersCurrentTab.tab = lastOrdersTabs.find(tab => tab.value === value)
}
